import React from 'react';
import { Button } from '@itwin/itwinui-react';
import { useConfigContext } from '../../../context';
import { t } from '../../../services/translation';
import type { SolutionType } from '../data/useSolutionType';
import { readUniversalLinkParams } from '../searchParams/searchParams';
import { useWebLink } from './useWebLink';

type WebLinkProps = {
  solutionType?: SolutionType;
};

export function WebLink({ solutionType }: WebLinkProps): JSX.Element | null {
  const { config } = useConfigContext();

  const webLink = useWebLink(solutionType);

  const { workAreaId, projectId, app } = readUniversalLinkParams();

  function navigateLink(): void {
    window.location.href = webLink;
  }

  function productName(): string {
    switch (solutionType) {
      case 'OpenConstruction': {
        return t('ProductName.Synchro');
      }
      case 'ProjectWise365': {
        return t('ProductName.ProjectWise365');
      }
      case 'web':
      default: {
        return t('ProductName.ProjectWiseWeb');
      }
    }
  }

  if (
    !workAreaId ||
    !projectId ||
    app == 'webview' ||
    config.DataAccessLevel == 'Datasource' ||
    !webLink ||
    !solutionType
  ) {
    return null;
  }

  return (
    <Button
      onClick={navigateLink}
      data-link={webLink}
      data-testid="projectwise-web-button"
    >
      {productName()}
    </Button>
  );
}
